import { EventType } from './eventTypes';

interface Subscription {
  event: EventType;
  callback: (args?: any) => void;
  space: string;
}

let subscriptions: Subscription[] = [];

class EventBus {
  space: string;

  constructor(space: string) {
    this.space = space;
  }

  on(event: EventType | EventType[], callback: (args?: any) => void) {
    if (Array.isArray(event)) {
      event.forEach(event => subscriptions.push({ event, callback, space: this.space }));
    } else {
      subscriptions.push({ event, callback, space: this.space });
    }
  }

  off(event: EventType | EventType[]) {
    if (Array.isArray(event)) {
      subscriptions = subscriptions.filter(item =>
        item.space === this.space ? !event.includes(item.event) : true,
      );
    } else {
      subscriptions = subscriptions.filter(item =>
        item.space === this.space ? item.event !== event : true,
      );
    }
  }

  emit(event: EventType, args?: any) {
    subscriptions.forEach(item => {
      if (item.event === event) {
        setTimeout(() => item.callback(args));
      }
    });
  }
}

export default EventBus;
